import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { Prompt, PromptInput } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  options?: Omit<UseMutationOptions<unknown, Error, PromptInput, Prompt>, 'mutationKey' | 'mutationFn'>;
}

export const useNewPromptRequest = ({ options = {} }: RequestParams = {}) => {
  const api = useApiInstance()

  return useMutation<unknown, Error, PromptInput, Prompt>(
    [Entities.Prompts, 'create'],
    async (payload: PromptInput) => {
      const { data } = await api.v1AdminPromptsPost(payload)
      return data
    },
    { ...options }
  )
}
